import script from "./TaskColumModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskColumModal.vue?vue&type=script&setup=true&lang=js"

import "./TaskColumModal.vue?vue&type=style&index=0&id=7efdce7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7efdce7c"]])

export default __exports__